webpackJsonp([49683490770531],{

/***/ "./node_modules/json-loader/index.js!./.cache/json/blog.json":
/***/ (function(module, exports) {

	module.exports = {"data":{"allPrismicDocument":{"edges":[{"node":{"first_publication_date":"2017-10-12T15:35:22+0000","fields":{"permalink":"/blog/who-cares-about-social-care"},"data":{"title":[{"type":"heading1","text":"Who Cares About Social Care?"}],"override_publication_date":"2017-11-06","excerpt":[{"type":"paragraph","text":"Google news searches for \"social care\" have never been higher than they were in 2011. Should we be worried?"}],"feature_image":{"url":"https://prismic-io.s3.amazonaws.com/careplanner/e32681d05de2175fc6c27893cfd3d1c677b70bb3_638833476.jpg"}}}}]}},"pathContext":{}}

/***/ })

});


// WEBPACK FOOTER //
// path---blog-9d62f6dbe854f6353a63.js